import {
  Popover as BasePopover,
  type PopoverContentProps,
  type PopoverRootProps,
} from "@ark-ui/react";
import { X } from "@phosphor-icons/react";
import clsx from "clsx";
import * as React from "react";
import { IconButton } from "../icon-button/IconButton.js";
import { useThemeContext } from "../theme/Theme.js";

interface BasePopoverContentProps extends PopoverContentProps {
  mode?: "light" | "dark";
  withCloseButton?: boolean;
  size?: "sm" | "md" | "lg";
  classNames?: {
    positioner?: string;
    content?: string;
    closeTrigger?: string;
  };
}

const Popover = BasePopover.Root;
const PopoverTrigger = BasePopover.Trigger;
const PopoverCloseTrigger = BasePopover.CloseTrigger;

const PopoverContent = (props: BasePopoverContentProps) => {
  const {
    className,
    classNames,
    children,
    mode = "light",
    withCloseButton = false,
    size = "sm",
    ...rest
  } = props;

  const { primaryColor, secondaryColor } = useThemeContext();
  return (
    <BasePopover.Positioner
      data-primary-color={primaryColor}
      data-secondary-color={secondaryColor}
      data-size={size}
      className={clsx(
        "ox-reset ox-PopoverPositioner",
        className,
        classNames?.positioner,
      )}
    >
      <BasePopover.Content
        data-mode={mode}
        data-size={size}
        {...rest}
        className={clsx("ox-reset ox-PopoverContent", classNames?.content)}
      >
        <BasePopover.Arrow>
          <BasePopover.ArrowTip />
        </BasePopover.Arrow>
        {withCloseButton ? (
          <BasePopover.CloseTrigger
            asChild
            className={clsx(
              "ox-reset ox-PopoverCloseTrigger",
              classNames?.closeTrigger,
            )}
            data-mode={mode}
          >
            <IconButton size="xs" variant="tertiary" color="gray">
              <X size={16} fill="currentColor" />
            </IconButton>
          </BasePopover.CloseTrigger>
        ) : null}
        {children}
      </BasePopover.Content>
    </BasePopover.Positioner>
  );
};

PopoverTrigger.displayName = "PopoverTrigger";
PopoverContent.displayName = "PopoverContent";

export { Popover, PopoverTrigger, PopoverContent, PopoverCloseTrigger };
export type { PopoverRootProps as PopoverProps };
